// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// UI框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 工具函数
import { format } from '@/utils/format'
import { validate } from '@/utils/validate'

// API请求
import request from '@/api/request'

// 全局配置
Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局混入
Vue.mixin({
  methods: {
    $format: format,
    $validate: validate
  }
})

// 全局属性
Vue.prototype.$format = format
Vue.prototype.$validate = validate
Vue.prototype.$axios = request

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js